import { Component, Input, SimpleChanges } from "@angular/core";
import { formatCell } from "src/app/utils/common";

import { VAIconRegistryService, infoCircle } from "@va/core-library/icons";
@Component({
  selector: "app-drug-sales-summary-marketed-drug",
  templateUrl: "./drug-sales-summary-marketed-drug.component.html",
  styleUrls: ["./drug-sales-summary-marketed-drug.component.scss"],
})
export class DrugSalesSummaryMarketedDrugComponent {
  @Input() data;
  constructor(private iconRegistryService: VAIconRegistryService) {
    this.iconRegistryService.registerIcons([infoCircle]);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes.data &&
      changes.data.currentValue &&
      changes.data.currentValue.marketed
    ) {
      const marketedData = changes.data.currentValue.marketed;
      const metaData = changes.data.currentValue.meta_data;

      const brokerAvg = formatCell(
        marketedData.analyst_avg_value,
        metaData.currency,
        metaData.unit,
        "values",
      );
      marketedData["analyst_avg_value_formatted"] = brokerAvg;

      const forecastData = marketedData.forcast_data;
      const actualData = forecastData.actual_data.map((_data) => {
        return {
          ..._data,
          value_formatted: formatCell(
            _data.value,
            metaData.currency,
            metaData.unit,
            "values",
          ),
        };
      });
      const estimatedData = forecastData.estimated_data.map((_data) => {
        return {
          ..._data,
          value_formatted: formatCell(
            _data.value,
            metaData.currency,
            metaData.unit,
            "values",
          ),
        };
      });
      forecastData.actual_data = actualData;
      forecastData.estimated_data = estimatedData;

      const peakValue = formatCell(
        marketedData.peak_value,
        metaData.currency,
        metaData.unit,
        "values",
      );
      marketedData["peak_value_formatted"] = peakValue;

      let threeYrsAfterPercent = formatCell(
        marketedData.three_year_after_data.percentage_change,
        metaData.currency,
        metaData.unit,
        "yoy",
      );
      if (threeYrsAfterPercent.includes("(")) {
        threeYrsAfterPercent = `(-${threeYrsAfterPercent.substring(1)}`;
      }
      if (threeYrsAfterPercent === "-") {
        threeYrsAfterPercent = null;
      }
      const threeYrsAfter = {
        ...marketedData.three_year_after_data,
        percentage_change_formatted: threeYrsAfterPercent,
        value_change_formatted: formatCell(
          marketedData.three_year_after_data.value_change,
          metaData.currency,
          metaData.unit,
          "values",
        ),
      };
      marketedData.three_year_after_data = threeYrsAfter;
    }
  }
}
